module.exports = __webpack_public_path__ + "img/HVU-icon-transparent-fff.993a0fce.svg";